export default "__VITE_ASSET__CVdKLl_Q__"